import React from 'react';
import './Copyright.css';

function Copyright() {
  return (
    <div className="Copyright">
        © 2020, All Rights Reserved
    </div>
  );
}

export default Copyright;